// extracted by mini-css-extract-plugin
export default {"form":"BuildingLoadingView_form__v5zNg","subHeader":"BuildingLoadingView_subHeader__Pxsve","heading":"BuildingLoadingView_heading__FGc7I"};